import { FlowConfig, RemoteConfig } from '@ca/common/types'
import { debugSteps } from './getDebugLog'

let lastFlowName: string | undefined = undefined
const debugFlow = (flowName: string, msg: string, ...args: any[]) => {
  if (lastFlowName !== flowName) {
    lastFlowName = flowName
    debugSteps.log(msg, flowName, ...args)
  }
}

export const DEFAULT_FLOW_NAME = 'classic'

/**
 * Resolves a flow configuration from the provided config and optional flow name.
 * Priority: explicit flow name → "classic" → legacy flow from region initial steps
 */
export const getFlow = (config: RemoteConfig | null, flowName?: string) => {
  if (!config) {
    throw new Error('Config is required')
  }

  if (flowName && config.flows?.[flowName]) {
    debugFlow(flowName, 'Using explicit flow', config.flows[flowName])
    return config.flows[flowName]
  }

  const defaultFlow = config.flows?.[DEFAULT_FLOW_NAME]

  if (defaultFlow) {
    debugFlow(DEFAULT_FLOW_NAME, 'Using default flow', defaultFlow)
    return defaultFlow
  }

  throw new Error('No flow found')
}
